import { Grid2, Stack, Typography } from '@mui/material';
import type { CSSProperties } from 'react';
import styled from 'styled-components';
import { primaryBlue } from '../models/colors';

export const Container = styled(({ container, ...props }: any) => <Stack {...props} />)`
	flex-basis: auto;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

export const Child = styled(({ item, ...props }: any) => <Grid2 {...props} />)`
	width: 100%;
	flex-basis: auto;
	justify-content: center;
	& + & {
		margin-top: 24px;
	}
`;

export const Title = styled((props: any) => (
	<Typography
		sx={{
			textAlign: 'center',
			fontWeight: 'bold',
			fontSize: '1.313rem',
			color: primaryBlue,
			marginBottom: '8px',
		}}
		{...props}
	/>
))``;

export const Subtitle = styled((props: any) => (
	<Typography
		sx={{
			textAlign: 'center',
			fontWeight: 'bold',
			fontSize: '1rem',
			color: primaryBlue,
			marginBottom: '16px',
		}}
		{...props}
	/>
))``;

export const Body = styled((props: any) => <Typography {...props} />)`
	width: 100%;
	margin: 0 auto;
	text-align: center;
	@media only screen and (max-width: 600px) {
		width: 80%;
	}`;

export const Heading = ({
	title,
	subtitle,
	titleStyle,
	subtitleStyle,
}: {
	title?: string;
	subtitle?: string;
	titleStyle?: CSSProperties;
	subtitleStyle?: CSSProperties;
}) => (
	<>
		{title ? (
			<Title variant={`h5`} style={titleStyle}>
				{title}
			</Title>
		) : null}
		{subtitle ? (
			<Subtitle variant={`h6`} style={subtitleStyle}>
				{subtitle}
			</Subtitle>
		) : null}
	</>
);

export const HomeHeading = styled(({ children, ...rest }: any) => <Child {...rest}>{children}</Child>)`
	justify-content: space-between;
	@media only screen and (max-width: 475px) {
		justify-content: center;
	}
`;
